<template>
  <!--draggable允许客户端拖拽区域-->
  <div class="draggable">
    <a v-if="$route.name === 'login'" href="javacript:void(0);" @click="close" class="btn_close" ></a>
    <a v-else href="javacript:void(0);" @click="close" class="btn_close1" :class="{'is-member': isMember}"></a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "compheader",
  computed: {
    ...mapGetters(["isMember"])
  },
  mounted () {
      console.log(this.$route)
  },
  methods: {
    close() {
      window.close();
      this.$emit("close");
      return false;
    }
  }
};
</script>

<style  lang="scss">
@import "@/assets/css/mixins.scss";
.draggable {
  width: 100%;
  height: 40px;
  -webkit-app-region: drag;
  position: absolute;
  z-index: 2;
  text-align: right;
}
.btn_close {
  -webkit-app-region: no-drag;
  display: inline-block;
  z-index: 3;
  @include icon_bg;
  width: 26px;
  height: 26px;
  background-position: -5px -262px;
  cursor: pointer;
  margin-right: 5px;
  margin-top: 3px;
  &:hover {
    background-position: -29px -262px;
  }
}

.btn_close1 {
    -webkit-app-region: no-drag;
    display: inline-block;
    z-index: 3;
    background: url(~@/assets/images/is-close.png) no-repeat left center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 5px;
    margin-top: 3px;
    &:hover {
        background-position-x: -24px;
    }
    &.is-member {
        background-image: url(~@/assets/images/not-close.png)
    }
}
</style>